import type { ChangePasswordInput, LoginInput } from '@financiar/shared';
import type { AuthenticatedUser } from '../../api/types';
import { apiClient } from '../../api/client';

export async function login(input: LoginInput): Promise<{ username: string }> {
  const { data } = await apiClient.post<{ username: string }>('/auth/login', input);
  return data;
}

/** `POST /auth/change-password` (task-8d-brief.md §4, `/setari` — Cont tab).
 * 204 No Content on success; the current session cookie stays valid, no
 * re-login needed. */
export async function changePassword(input: ChangePasswordInput): Promise<void> {
  await apiClient.post('/auth/change-password', input);
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function fetchMe(): Promise<AuthenticatedUser> {
  const { data } = await apiClient.get<AuthenticatedUser>('/auth/me');
  return data;
}
